import React from 'react'
import { Link } from 'react-router-dom'

import { NewIconArrow } from '../../icons/NewIconArrow'
import { NewButtonProps } from './NewBackButton.types'

export const NewBackButton = ({ url, name }: NewButtonProps) => {
  return (
    <Link className={`btn btn--gray btn--small btn--back`} to={url ? url : '/'}>
      <NewIconArrow />
      {name ? name : 'На главную'}
    </Link>
  )
}
